"use client";

import { isSignedInAtom } from "@/hooks/authAtoms";
import { getAccessToken } from "@/utils/functions/cookieOperations";
import { useSetAtom } from "jotai";
import { useEffect } from "react";

/**
 * Writes the real signed-in state into {@link isSignedInAtom} after hydration. The atom
 * starts `false` so the server and hydration renders agree, so something has to promote it,
 * on every page — hence the root layout. Not <ValidateAccessToken/>, which does the same
 * sync but also refetches the profile on every page load.
 */
const SyncAuthState = () => {
  const setIsSignedIn = useSetAtom(isSignedInAtom);

  useEffect(() => {
    setIsSignedIn(!!getAccessToken());
  }, [setIsSignedIn]);

  return null;
};

export default SyncAuthState;
